import { HEADER_SCROLLED } from '@constants'

export default function action(scrolled) {
  return { type: HEADER_SCROLLED, payload: scrolled }
}
